import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment-timezone';
import { Description, Feature, ReleaseNote, ReleaseTitle } from './release-note.types';

const NUM_DAYS_RELEASE_IS_NEW = 10;

export interface ReleaseNotesData {
  releaseNotes: ReleaseNote[];
}

@Component({
  selector: 'hk-release-notes',
  templateUrl: './release-notes.component.html',
})
export class ReleaseNotesModalComponent {
  public releaseNotes: ReleaseNote[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { releaseNotes: ReleaseNote[] },
    public dialog: MatDialog,
    public translate: TranslateService,
  ) {
    this.releaseNotes = this.data.releaseNotes;
  }

  public isNewReleaseNote(note: ReleaseNote): boolean {
    return moment(note.releaseDate, 'DD.MM.YYYY').isSameOrAfter(moment().subtract(NUM_DAYS_RELEASE_IS_NEW, 'days'));
  }

  public getLocalizedFeature(feature: Feature, name: string, fallback: string | string[]) {
    return (
      feature?.[this.translate.currentLang as 'en' | 'de']?.[name as keyof Description] ??
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (feature as any)?.[this.translate.defaultLang]?.[name] ??
      fallback
    );
  }

  public getLocalizedTitle(note: ReleaseNote, fallback: string | string[]) {
    return (
      note.title?.[this.translate.currentLang as keyof ReleaseTitle] ??
      note.title?.[this.translate.defaultLang as keyof ReleaseTitle] ??
      fallback
    );
  }
}
